import * as React from 'react';
import { useTextMessaging } from '../../../../models/hooks/appStateHooks';
import { useConversationsInfiniteQuery } from '../../../../queries/Conversation/useConversationsInfiniteQuery';

export function useRefreshConversations({ unreadOnly, spamOnly }: { unreadOnly: boolean; spamOnly: boolean }) {
	const textMessagingVM = useTextMessaging();

	const query = useConversationsInfiniteQuery({
		enabled: Boolean(textMessagingVM?.id),
		meta: {
			errorLogging: {
				category: 'useRefreshConversations',
				action: 'ConversationsRefresh-Error',
			},
		},
		phoneNumberId: textMessagingVM?.id,
		spamOnly,
		unreadOnly,
	});

	React.useEffect(() => {
		if (textMessagingVM?.id && !query.isFetching && query.data?.pages?.length) {
			textMessagingVM.addConversations(query.data.pages[0].values);
		}
	}, [query.data?.pages, query.isFetching, textMessagingVM]);
}
